import React, { Fragment } from "react";
import Seo from "../../components/utils/Seo";
import Base from "../Base";
import BodyDocumentation from "./BodyDocumentation";

const DocumentationPage = (props) => {
  return (
    <Fragment>
      <Seo
        title="nti / documentation"
        description="Reponse aux questions d'administration de la boutique"
      />
      <Base>
        <BodyDocumentation />
      </Base>
    </Fragment>
  );
};

export default DocumentationPage;
